<template>
  <el-form ref="applyAgentForm" label-width="auto" :model="detail">
    <div class="confirm">
      <div>
        <van-cell-group>
          <van-field
            v-model="detail.storeName"
            placeholder="请输入店铺名"
            size="large"
          />

          <van-field
            v-model="detail.ownerName"
            placeholder="登记人姓名"
            size="large"
          />

          <van-field
            v-model="detail.ownerIdNum"
            placeholder="登记人身份证"
            size="large"
          />

          <van-field
            v-model="detail.license"
            placeholder="营业执照"
            size="large"
          />

          <van-row type="flex" align="center">
            <van-col span="18">
              <van-field
                :value="detail.expiredDate"
                placeholder="营业执照有效期截止时间"
                readonly
                right-icon="arrow-down"
                size="large"
                @click="dateShow = true"
              >
              </van-field>
            </van-col>
            <van-col span="6">
              <van-checkbox v-model="detail.islongVaild" checked-color="#000000"
                >长期</van-checkbox
              >
            </van-col>
          </van-row>

          <van-field
            v-model="detail.email"
            placeholder="请输入Email"
            size="large"
          />

          <van-field
            v-model="allAddress"
            placeholder="请选省、市、区"
            readonly
            @click="addreShow = true"
          />

          <van-field
            v-model="detail.address"
            placeholder="详细地址"
            size="large"
          />

          <!-- ================身份证照片================================================================-->

          <van-cell title="身份证照片" :border="false" />

          <van-row>
            <van-col span="12">
              <van-cell :border="false">
                <template #default>
                  <uplode-input3
                    :value="detail.idCardFrontUrl"
                    :asyncUpdate="true"
                    prop="idcardFrontUrl"
                    keyName="idcardFrontUrl"
                    :showTip="false"
                    :limit="20"
                    @uplodeChange="uplodeChange($event, 1)"
                  ></uplode-input3>
                </template>
              </van-cell>
            </van-col>
            <van-col span="12">
              <van-cell :border="false">
                <template #default>
                  <uplode-input3
                    :value="detail.idCardBackUrl"
                    :asyncUpdate="true"
                    prop="idcardBackUrl"
                    keyName="idcardBackUrl"
                    :showTip="false"
                    :limit="20"
                    @uplodeChange="uplodeChange($event, 2)"
                  ></uplode-input3>
                </template>
              </van-cell>
            </van-col>
          </van-row>

          <!-- ================店铺证件================================================================-->

          <van-cell title="店铺证件" :border="false" />

          <van-cell :border="false">
            <template #default>
              <uplode-input3
                :asyncUpdate="true"
                tip="营业执照"
                prop="idcardUrl"
                keyName="idcardUrl"
                :limit="20"
                :value="detail.businessLicenseUrl"
                @uplodeChange="uplodeChange($event, 0)"
              ></uplode-input3>
            </template>
          </van-cell>

          <!-- ================门店实景图================================================================-->
          <van-cell title="门店实景图" :border="false" />

          <upload-more
            v-model="selectShopImgUrls"
            prop="registerCertificationUrl"
          ></upload-more>
        </van-cell-group>
        <div class="submit" @click="submit">
          提交
        </div>
      </div>
    </div>

    <van-popup v-model="dateShow" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :formatter="formatter"
        @confirm="onDateConfirm"
        @cancel="dateShow = false"
      />
    </van-popup>

    <van-popup v-model="addreShow" round position="bottom">
      <van-cascader
        title="请选择所在地区"
        :options="options"
        name=""
        @close="addreShow = false"
        @finish="onFinish"
        :field-names="{
          text: 'areaName',
          value: 'areaCode',
          children: 'childList',
        }"
      />
    </van-popup>
  </el-form>
</template>

<script>
import {
  ImagePreview,
  //   Calendar,
  Checkbox,
  CellGroup,
  Cascader,
  Popup,
  DatetimePicker,
  //   Radio,
  Col,
  Row,
} from "vant";
import uplodeInput3 from "@/views/formComponents/uplodeInput3";
import uploadMore from "@/views/formComponents/uploadmore";

export default {
  components: {
    uplodeInput3,
    uploadMore,
    // Calendar,
    "van-checkbox": Checkbox,
    "van-popup": Popup,
    "van-cascader": Cascader,
    "van-cell-group": CellGroup,
    "van-datetime-picker": DatetimePicker,
    // "van-radio": Radio,
    "van-col": Col,
    "van-row": Row,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  data() {
    return {
      loading: false,
      show: false,
      addreShow: false,
      detail: {},
      options: [],
      selectShopImgUrls: [],
      currentDate: new Date(),
      minDate: new Date(),
      dateShow: false,
      CACHE_KEY: "storeAuth_formCache", // 缓存键名
    };
  },
  watch: {
    // 监听表单数据变化，自动保存到缓存
    detail: {
      handler() {
        this.saveFormCache();
      },
      deep: true,
    },
    // 监听店铺图片变化
    selectShopImgUrls: {
      handler() {
        this.saveFormCache();
      },
      deep: true,
    },
  },
  computed: {
    allAddress() {
      if (this.detail.provinceName) {
        return `${this.detail.provinceName}${this.detail.cityName}${this.detail.districtName}`;
      }
      return "";
    },
  },
  mounted() {
    this.getAddressData();
    this.restoreFormCache(); // 先恢复缓存数据
    this.getInitDetail();
  },
  methods: {
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      }
      return value;
    },
    onDateConfirm(date) {
      this.dateShow = false;
      this.$set(this.detail, 'expiredDate', this.formatDate(date));
    },
    onFinish({ selectedOptions }) {
      this.addreShow = false;

      if (selectedOptions.length == 3) {
        this.$set(this.detail, 'provinceName', selectedOptions[0].areaName);
        this.$set(this.detail, 'cityName', selectedOptions[1].areaName);
        this.$set(this.detail, 'districtName', selectedOptions[2].areaName);

        this.$set(this.detail, 'provinceId', selectedOptions[0].areaCode);
        this.$set(this.detail, 'cityId', selectedOptions[1].areaCode);
        this.$set(this.detail, 'districtId', selectedOptions[2].areaCode);
      }
    },
    getAddressData() {
      // 获取地址数据
      const url = "/api/front/order/address/getAllAddress";
      this.$request(url)
        .then((res) => {
          if (res.code === 1) {
            this.options = res.data;
          }
        })
        .catch(() => {});
    },
    formatDate(date) {
      var mmonth = `${date.getMonth() + 1}`;
      if (`${date.getMonth() + 1}`.length == 1) {
        mmonth = `0${date.getMonth() + 1}`;
      }

      var mdate = `${date.getDate()}`;
      if (`${date.getDate()}`.length == 1) {
        mdate = `0${date.getDate()}`;
      }
      return `${date.getFullYear()}-${mmonth}-${mdate}`;
    },
    getInitDetail() {
      console.log("getInitDetail=======");
      let objStr = localStorage.getItem("RegisterAuthInfo");
      if (objStr) {
        var obj = JSON.parse(objStr);
        obj.islongVaild = false;
        // 只有在detail为空或没有缓存数据时才使用RegisterAuthInfo的数据
        if (!this.detail || Object.keys(this.detail).length === 0) {
          this.detail = obj;
        }
      }
    },
    // 保存表单数据到缓存
    saveFormCache() {
      const cacheData = {
        detail: this.detail,
        selectShopImgUrls: this.selectShopImgUrls,
        timestamp: new Date().getTime(),
      };
      localStorage.setItem(this.CACHE_KEY, JSON.stringify(cacheData));
    },
    // 恢复缓存的表单数据
    restoreFormCache() {
      const cacheStr = localStorage.getItem(this.CACHE_KEY);
      if (cacheStr) {
        try {
          const cacheData = JSON.parse(cacheStr);
          if (cacheData.detail) {
            this.detail = cacheData.detail;
          }
          if (cacheData.selectShopImgUrls) {
            this.selectShopImgUrls = cacheData.selectShopImgUrls;
          }
          console.log("已恢复缓存的表单数据");
        } catch (e) {
          console.error("恢复缓存数据失败:", e);
        }
      }
    },
    // 清除表单缓存
    clearFormCache() {
      localStorage.removeItem(this.CACHE_KEY);
      console.log("已清除表单缓存");
    },

    onClose() {
      this.show = false;
    },
    onConfirm(date) {
      this.show = false;
      this.$set(this.detail, 'islongVaild', false);
      this.$set(this.detail, 'expiredDate', this.formatDate(date));
    },

    uplodeChange(value, type) {
      if (type == 0) {
        this.$set(this.detail, "businessLicenseUrl", value.idcardUrl ?? "");
      } else if (type == 1) {
        this.$set(this.detail, "idCardFrontUrl", value.idcardFrontUrl ?? "");
      } else if (type == 2) {
        this.$set(this.detail, "idCardBackUrl", value.idcardBackUrl ?? "");
      }
    },
    showToast(msg) {
      this.$message({
        message: msg,
        type: "none",
        customClass: "zidingyiel_message",
      });
    },

    submit() {
      if (this.loading) {
        return;
      }
      //   if (!this.detail.storeName) {
      //     this.showToast("店铺名称不能为空");
      //     return;
      //   } else if (!this.detail.ownerName) {
      //     this.showToast("登记人姓名不能为空");
      //     return;
      //   } else if (!this.detail.ownerIdNum) {
      //     this.showToast("登记人身份证不能为空");
      //     return;
      //   } else if (!this.detail.license) {
      //     this.showToast("营业执照不能为空");
      //     return;
      //   } else if (!this.detail.islongVaild && !this.detail.expiredDate) {
      //     this.showToast("营业执照有效期不能为空");
      //     return;
      //   } else if (!this.detail.address) {
      //     this.showToast("详细地址不能为空");
      //   } else if (!this.detail.idCardFrontUrl) {
      //     this.showToast("请先上传身份证人像面");
      //     return;
      //   } else if (!this.detail.idCardBackUrl) {
      //     this.showToast("请先上传身份证国徽面");
      //     return;
      //   } else if (!this.detail.businessLicenseUrl) {
      //     this.showToast("营业执照图片不能为空");
      //     return;
      //   } else if (!this.selectShopImgUrls.length) {
      //     this.showToast("至少上传一张门店实景图");
      //     return;
      //   }

      var params = {
        type: 0,
        email: this.detail.email,
        name: this.detail.storeName,
        idcardName: this.detail.ownerName,
        idcardNumber: this.detail.ownerIdNum,
        idcardFrontUrl: this.detail.idCardFrontUrl,
        idcardBackUrl: this.detail.idCardBackUrl,
        country: "中国",
        provinceId: this.detail.provinceId,
        cityId: this.detail.cityId,
        districtId: this.detail.districtId,
        address: this.detail.address,
        isPhysical: 1,
        businessLicense: this.detail.license,
        operatingPeriod: this.detail.islongVaild
          ? "长期有效"
          : this.detail.expiredDate,
        businessLicenseUrl: this.detail.businessLicenseUrl,
        data: {
          shopImgUrls: this.selectShopImgUrls.map((item) => item.url),
        },
      };
      debugger;
      let token = localStorage.getItem("RegisterToken");
      const url = "/api/front/storeDs/submitCertification";
      this.$request(url, {
        method: "POST",
        data: params,
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          this.loading = false;
          if (res.code === 1) {
            // 提交成功后清除所有缓存数据
            this.clearFormCache();
            localStorage.removeItem("RegisterAuthInfo");
            localStorage.removeItem("RegisterToken");
            this.$router.push(`/download/app/distributor?type=1`);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.confirm {
  background: white;

  ::v-deep .van-nav-bar {
    background: rgba(253, 40, 36, 0.05);
    font-size: 16px;
    font-weight: 500;
  }

  ::v-deep .van-cell__title {
    text-align: left;
  }

  .pics {
    display: flex;
    flex-wrap: wrap;
    padding: 0 12px;

    .pic_item {
      width: calc(50vw - 12px);

      .pic_back {
        text-align: center;
        position: relative;
        width: 100%;
        height: 0;
        padding-top: 60%;
      }

      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 90%;
        height: 90%;
        max-width: 90%;
        max-height: 90%;
        margin-top: 5%;
        margin-left: 5%;
      }
    }
  }

  .agree {
    padding: 32px;
  }

  .hint {
    font-size: 12px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.5);
    padding: 0 36px;
    text-align: left;
  }

  .submit {
    margin: 40px 12px 24px 12px;
    background: linear-gradient(90deg, #fd2824, #fe3d6c 100%);
    font-weight: 500;
    font-size: 14px;
    color: white;
    cursor: pointer;
    height: 36px;
    line-height: 36px;
    border-radius: 18px;
  }
}
</style>
